import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import Common from './Common';
import Auth from './Auth';
import Settings from './Settings';
import Menu from './Menu';
import Notification from './Notification';
import AuthEntity from './AuthEntity';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    auth: Auth,
    authEntity: AuthEntity,
    menu: Menu,
    settings: Settings,
    notification: Notification,
  });
